module.exports = __webpack_public_path__ + "img/green-tick-light.44ee075b.svg";